import React, { useState, useContext } from "react"
import "../css/navbar.css"
import Winners from "../winners"
import Select from "react-select"
import { useNavigate } from "react-router-dom"
import { LanguageContext } from "../LanguageContext"
import { useTranslation } from "react-i18next";
import {service,customStyles,getLanguages} from "../../utils/constant";

const Navbar = () => {
  const { t } = useTranslation("global")
  const [isNavExpanded, setIsNavExpanded] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const { language, changeLanguage } = useContext(LanguageContext)
  const navigate = useNavigate()


  const openModal = () => {
    setIsOpen(true)
  }

  const closeModal = () => {
    setIsOpen(false)
  }

  const onLogout = () => {
    //localStorage.clear()
    window.location.href = "/unsub"
  }

  const handleChange = (selectedOption) => {
    changeLanguage(selectedOption.value)
  }

  let languages = getLanguages();
  const selectedOption = languages.find((option) => option.value === language)
  const token = localStorage.getItem("token")
  
  return (
    <>
      <nav className="navigation">
        <a href="/" className="brand-name">
           {service==="mng" ? 
              <img src="/images/logo_mng.png" alt="UV Games Logo" className="img-logo" /> 
           :(service==="mueg"?
              <img src="/images/logo_mueg.png" alt="UV Games Logo" className="img-logo-mueg" />
           :
              <img src="/images/uv_games_logo.png" alt="UV Games Logo" className="img-logo" />
           )
          }
        </a>
        <div>
          {/* {!!token && ( */}
          <div className="mobile-icons"> 
             {!!token && (
                <button
                  className="mobile-home-button home_button"
                  onClick={onLogout}
                >
                  <i className="fas fa-house"></i>
                </button>
              )}           
              <button
                className="mobile-android-button winners_button"
                onClick={() => navigate("/allGames/Android")}
              >
                <i className="fa fa-android"></i>
              </button>

              <button
                className="mobile-winner-button winners_button"
                onClick={openModal}
              >
                <i className="fa-solid fa-trophy"></i>
              </button>
             
          </div>

          {/* )} */}
          <button
            className="hamburger"
            onClick={() => {
              setIsNavExpanded(!isNavExpanded)
            }}
          >
            <i className="fa-solid fa-bars"></i>
          </button>
        </div>

        <div
          className={
            isNavExpanded ? "navigation-menu expanded" : "navigation-menu"
          }
        >
          <ul>
            <li>
              <a href="/allGames/Sports">{t("portalText.sport")}</a>
            </li>
            <li>
              <a href="/allGames/Funny">{t("portalText.funny")}</a>
            </li>
            <li>
              <a href="/allGames/Action">{t("portalText.action")}</a>
            </li>
            <li>
              <a href="/allGames/Adventure">{t("portalText.adventure")}</a>
            </li>
            <li>
              <a href="/allGames/Racing">{t("portalText.racing")}</a>
            </li>
            <li>
              <a href="/allGames/Kids">{t("portalText.kids")}</a>
            </li>
            <li>
              <a href="/allGames/Puzzle">{t("portalText.puzzle")}</a>
            </li>
            <li className="mobile-category">
              <a href="/allGames/Android">{t("portalText.android")}</a>
            </li>
            {/* <li>
                <a href="/allGames/Sports">Arcade</a>
            </li> */}

            <>
            {!!token && (
              <li>
                  <button
                    className="logout_button tabletdesktop-logout-button"
                    onClick={onLogout}
                  >
                    <i className="fas fa-house"></i>
                  </button>
              </li>
              )}
              <li>
                {/* <a href="/allGames/Android" className="brand-name"> */}
                <button
                  className="winners_button tabletdesktop-winner-button"
                  onClick={() => navigate("/allGames/Android")}
                >
                  <i className="fa fa-android"></i> {t("portalText.android")}
                </button>
                {/* </a> */}
              </li>
              <li>
                <button
                  className="winners_button tabletdesktop-winner-button"
                  onClick={openModal}
                >
                  <i className="fa-solid fa-trophy"></i>{" "}
                  {service==="mng"?t("portalText.leaderboard"):t("portalText.winners")}
                </button>
              </li>
              <Select
                value={selectedOption}
                options={languages}
                onChange={handleChange}
                styles={customStyles}
                placeholder="Select Language"
              />

             
            </>
          </ul>
        </div>
      </nav>
      {/* {!!token && <Winners isOpen={isOpen} closeModal={closeModal} />} */}
      <Winners isOpen={isOpen} closeModal={closeModal} />
    </>
  )
}

export default Navbar
